import React from 'react';
import { Link } from 'react-router-dom';

const AcademiaVendas = () => {
  return (
    <div style={{ height: 'calc(100vh - 12px)', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 12px' }}>
        <strong>Academia Business de Vendas</strong>
        <Link to="/dashboard">Voltar ao painel</Link>
      </div>
      <iframe
        title="Academia Business de Vendas"
        src="/academia-vendas/index.html"
        style={{ flex: 1, width: '100%', border: 0 }}
      />
    </div>
  );
};

export default AcademiaVendas;
